import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const OurOfferingsRag = () => {
    return (
        <div className="section-py !pb-12 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-0 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our Offerings
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-10">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/llms-aiml/svg/ic_ragpipeline.svg" width={36} height={36} alt="RAG pipelines" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">RAG pipelines & document ingestion</p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/llms-aiml/svg/ic_customchatbots.svg" width={36} height={36} alt="Custom chatbots" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Custom chatbots & virtual assistants
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_enterpriseknowledge.svg"
                                width={36}
                                height={36}
                                alt="Enterprise knowledge bases"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Enterprise knowledge bases + semantic search
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_multilingualsupport.svg"
                                width={36}
                                height={36}
                                alt="Multilingual support"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Multilingual support & localization
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_voiceassistants.svg"
                                width={36}
                                height={36}
                                alt="Voice assistants"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Voice assistants (STT/TTS pipelines)
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-2 mb-[50px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_promptengineering.svg"
                                width={36}
                                height={36}
                                alt="prompt engineering"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Prompt engineering & persona design
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_embeddingsgeneration.svg"
                                width={36}
                                height={36}
                                alt="embeddings generation"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Embeddings generation & vector database management
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/llms-aiml/svg/ic_llmfinetuning.svg" width={36} height={36} alt="LLM fine-tuning" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            LLM fine-tuning / PEFT (LoRA / QLoRA) for domain adaptation
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_secureintegration.svg"
                                width={36}
                                height={36}
                                alt="Secure integrations"
                            />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Secure integrations & MLOps for enterprise
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/llms-aiml/svg/ic_langchain_powered.svg" width={36} height={36} alt="LangChain-powered" />
                        </div>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            LangChain-powered workflow orchestration via MCP
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 bg-ready-transform rounded-10 relative">
                    <div className="counter-overlay"></div>
                    <div className="lg:col-span-12 lg:p-12 md:p-5 p-5 relative z-[1]">
                        <h2 className="mb-3 text-white">Ready to Transform Your Enterprise Knowledge into Intelligent Action?</h2>
                        <p className="mb-3 text-white">
                            Request a demo to see production-ready RAG pipelines and enterprise chatbots in action
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Schedule a call with us'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurOfferingsRag;
